import{useContext as t}from"react";import o from"./context";const r=()=>t(o);export default r;